import { CircleAlert, AlertTriangle, Info } from 'lucide-react'

interface IssueCardProps {
  type: string
  severity: 'critical' | 'warning' | 'info'
  title: string
  description: string
  recommendation?: string
  count?: number
  onClick?: () => void
}

const SEVERITY_CONFIG = {
  critical: { label: 'Critique', bg: 'bg-red-500/10', text: 'text-red-400', badge: 'bg-red-500/15 text-red-400', Icon: CircleAlert },
  warning:  { label: 'Attention', bg: 'bg-amber-500/10', text: 'text-amber-400', badge: 'bg-amber-500/15 text-amber-400', Icon: AlertTriangle },
  info:     { label: 'Info', bg: 'bg-cyan-500/10', text: 'text-cyan-400', badge: 'bg-cyan-500/15 text-cyan-400', Icon: Info },
}

export function IssueCard({ severity, title, description, recommendation, count, onClick }: IssueCardProps) {
  const config = SEVERITY_CONFIG[severity]
  const IconComp = config.Icon
  return (
    <div className={`bg-white border border-[#E2E4ED] rounded-xl p-4${onClick ? ' cursor-pointer hover:shadow-sm transition-shadow' : ''}`} onClick={onClick}>
      <div className="flex items-start gap-3">
        <div className={`p-2 rounded-lg ${config.bg}`}>
          <IconComp className={`w-4 h-4 ${config.text}`} strokeWidth={1.25} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <span className={`text-[11px] font-semibold px-2 py-0.5 rounded-full ${config.badge}`}>
              {config.label}
            </span>
            {count && count > 1 && (
              <span className="text-[11px] text-[#555A73] font-mono">{count} occurrences</span>
            )}
          </div>
          <h4 className="font-medium text-[#1B2559] text-sm">{title}</h4>
          <p className="text-sm text-[#8B8FA7] mt-1">{description}</p>
          {recommendation && (
            <p className="text-sm text-[#555A73] mt-2 italic">→ {recommendation}</p>
          )}
        </div>
      </div>
    </div>
  )
}
